import{css as e}from"@lokalise/styled";const o=e`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;export{o as oneLineEllipsis};
//# sourceMappingURL=oneLineEllipsis.js.map
